module.exports = __webpack_public_path__ + "static/media/fgrs.b06ef266.svg";